import {
  EnvironmentProviders,
  inject,
  makeEnvironmentProviders,
  provideAppInitializer,
} from '@angular/core';
import { AuthService } from './auth';
import { AUTH_CONFIG, type AuthConfig, resolveAuthConfig } from './auth-config';

/**
 * Registers tenant auth config and restores the session before routing.
 *
 * Interceptors stay app-owned: call
 * `provideHttpClient(withInterceptors([authInterceptor, ...]))` so hosts can
 * compose additional interceptors (Angular does not merge nested
 * `provideHttpClient` calls).
 */
export function provideAuth(config: AuthConfig): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: AUTH_CONFIG, useValue: resolveAuthConfig(config) },
    provideAppInitializer(() => inject(AuthService).initialize()),
  ]);
}
